import { render, staticRenderFns } from "./preview-image.vue?vue&type=template&id=ef6b2d52&scoped=true&"
import script from "./preview-image.vue?vue&type=script&lang=js&"
export * from "./preview-image.vue?vue&type=script&lang=js&"
import style0 from "./preview-image.vue?vue&type=style&index=0&id=ef6b2d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6b2d52",
  null
  
)

export default component.exports